import rtk /* , {set, update } */ from 'rtk';
import {
  name,
  UPLOADING,
  PROCESSING,
  ANALYZING,
  READY,
  FAILED,
} from './constants';
import { selectDeviceId, send, progress, uploaded, clear } from './actions';
import { persisted } from 'local-storage/persistence';
const { createReducer } = rtk(name);

const initialState = {
  uploads: {},
  selectedDeviceId: persisted(null),
};

export const reducer = createReducer(initialState, {
  [selectDeviceId]: (state, { payload: { deviceId } }) => {
    console.log(deviceId);
    state.selectedDeviceId = deviceId;
  },
  [send.pending]: (state, { meta: { requestId, arg: file } }) => {
    state.uploads[requestId] = {
      uuid: requestId,
      progress: 0,
      filename: file?.name,
      id: undefined,
      error: undefined,
      status: UPLOADING,
    };
  },
  [progress]: (state, { payload: { requestId, progress } }) => {
    state.uploads[requestId].progress = progress;
    if (progress === 1) {
      state.uploads[requestId].status = PROCESSING;
    }
  },
  [uploaded]: (state, { payload: { requestId, id } }) => {
    state.uploads[requestId].id = id;
    state.uploads[requestId].status = ANALYZING;
  },
  [send.fulfilled]: (state, { payload: upload, meta: { requestId } }) => {
    state.uploads[requestId] = {
      ...state.uploads[requestId],
      ...upload.attributes,
      status: READY,
    };
  },
  [send.rejected]: (state, { error, meta: { requestId } }) => {
    state.uploads[requestId].error = error;
    state.uploads[requestId].status = FAILED;
    return state;
  },
  [clear]: (state, { payload: { uuid } }) => {
    const upload = state.uploads[uuid];
    if (upload?.status === READY || upload?.status === FAILED) {
      delete state.uploads[uuid];
    } else {
      return state;
    }
  },
});
